import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.div``

const GreenhouseEmbed = () => {
	return (
		<Wrapper id='gh_wrapper'>
			<iframe
				id="grnhse_iframe"
				width="100%"
				frameBorder="0"
				scrolling="no"
				allow="geolocation"
				title="Greenhouse Job Board"
				src="https://boards.greenhouse.io/embed/job_board?for=koalafi"
				height="5800"
			/>
		</Wrapper>
	)
}

export default GreenhouseEmbed
